import { Middleware } from '@reduxjs/toolkit';

const middlewares: Middleware[] = [];

if (!__SERVER__) {
	// eslint-disable-next-line @typescript-eslint/no-require-imports
	middlewares.push(require('./middlewares/width').default);
}

export default middlewares;
